const ZhCn = {
    welcome: "欢迎"
}

export default ZhCn;